export const CONTENT_TYPE_ARTICLE = 'article'
export const CONTENT_TYPE_QUESTION = 'question'
export const CONTENT_TYPE_DISCUSSION = 'discussion'
export const CONTENT_TYPE_CONVERSATION = 'conversation'
export const CONTENT_TYPE_IDEA = 'idea'
export const CONTENT_TYPE_PRODUCT_UPDATE = 'productUpdate'

export type ContentType =
    typeof CONTENT_TYPE_ARTICLE |
    typeof CONTENT_TYPE_QUESTION |
    typeof CONTENT_TYPE_DISCUSSION |
    typeof CONTENT_TYPE_IDEA |
    typeof CONTENT_TYPE_PRODUCT_UPDATE |
    typeof CONTENT_TYPE_CONVERSATION

export function isArticle (contentType: ContentType) {
  return contentType === CONTENT_TYPE_ARTICLE
}

export function isQuestion (contentType: ContentType) {
  return contentType === CONTENT_TYPE_QUESTION
}

export function isDiscussion (contentType: ContentType) {
  return contentType === CONTENT_TYPE_DISCUSSION
}

export function isConversation (contentType: ContentType) {
  return contentType === CONTENT_TYPE_CONVERSATION
}

export function isIdea (contentType: ContentType) {
  return contentType === CONTENT_TYPE_IDEA
}

export function isProductUpdate (contentType: ContentType) {
  return contentType === CONTENT_TYPE_PRODUCT_UPDATE
}

export function getConsistentContentType (contentType: ContentType) {
  return isDiscussion(contentType) ? CONTENT_TYPE_CONVERSATION : contentType
}
